import React from "react";
import Marquee from "react-fast-marquee";

export const BrandMarquee = ({ items, dark = false }) => (
  <div className={`py-8 border-y ${dark ? "bg-navy border-gold/20" : "bg-ivory border-navy/10"}`} data-testid="marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className={`editorial-text text-5xl lg:text-7xl px-8 ${dark ? "text-ivory" : "text-navy"}`}>{it}</span>
          <span className="text-gold text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
